// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__1cM0o","errorImage":"Error_errorImage__2OPxO"};